import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import { FAIcon, IconStyle } from '../../components';
import { toggleLanguage } from '../../../sdk/store/headerActions';
import i18nConfig from '../../i18n/config';
import styles from './ChangeLanguage.module.scss';

export const ChangeLanguage = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { isLanguageOpen } = useAppSelector(state => state.header);

  const langResources = i18nConfig?.options?.resources ?? {};
  const defaullLang = localStorage.getItem('locale') ?? 'en';
  const langList = Object.keys(langResources);

  const [selectedOption, setSelectedOption] = useState(langResources[defaullLang]?.name as string);

  const handleOptionClick = (value: string) => {
    setSelectedOption(langResources[value]?.name as string);
    dispatch(toggleLanguage(false));

    i18n.changeLanguage(value);
    localStorage.setItem('locale', value);
  };

  const toggleHandler = () => {
    dispatch(toggleLanguage(!isLanguageOpen));
  };

  if (langList.length > 1) {
    return (
      <div className={styles['framework-change-language']}>
        <div className={styles['dropdown-toggle']} onClick={toggleHandler}>
          <span>{selectedOption}</span>
          <FAIcon iconName="caret-down" iconStyle={IconStyle.SOLID} />
        </div>
        {isLanguageOpen && (
          <div className={styles['dropdown-menu']}>
            {langList.map((locale: string) => (
              <div key={locale} className={styles['dropdown-item']} onClick={() => handleOptionClick(locale)}>
                {langResources[locale]?.name as string}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};
